import { render, staticRenderFns } from "./howItWorks.vue?vue&type=template&id=8d17cf64"
import script from "./howItWorks.vue?vue&type=script&lang=js"
export * from "./howItWorks.vue?vue&type=script&lang=js"
import style0 from "./howItWorks.vue?vue&type=style&index=0&id=8d17cf64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports